/* eslint-disable camelcase */
import { MultiLanguageText } from './MultiLanguageText';

export class CartItem {
  constructor(product_guid, product_name_alt1, product_name_alt2, product_name_alt3, price, quantity) {
    this.guid = product_guid || '0';
    this.name = this.getMultiLanguageName(product_name_alt1, product_name_alt2, product_name_alt3);
    this.price = price || 0;
    this.quantity = quantity || 0;
  }

  getMultiLanguageName(product_name_alt1, product_name_alt2, product_name_alt3) {
    const name = {
      alt1: product_name_alt1,
      alt2: product_name_alt2,
      alt3: product_name_alt3
    };
    return new MultiLanguageText(name);
  }

  static toInstance(props = {}) {
    return new CartItem(props.product_guid, props.product_name_alt1, props.product_name_alt2, props.product_name_alt3, props.price, props.quantity);
  }

  static toInstanceList(list = []) {
    return list.map(this.toInstance);
  }
}
